import React from 'react'
import { useQuery } from 'jsonapi-react'

import BaseSceneAlbum from 'scenes/baseAlbumScene'
import Avatar from 'components/Avatar'


export default function SceneAlbum(props) {
  const userId = props.match.params.userId

  const { data:user = [], isLoading } = useQuery(userId && [
    'users',
    userId,
    {
      include: 'profile_pic'
    },
  ])

  let query = ['albums']

  if (userId) {
    query = ['users', userId, 'albums']
  }

  return (
    <BaseSceneAlbum
      query={query}
      baseRedirect={userId ? `/users/${userId}/albums` : '/albums'}
      baseRedirectEmpty={userId ? `/users/${userId}/albums` : '/albums'}
      loading={isLoading}
      headers={
        userId &&
        <Avatar
          withDescription
          className='pt-10'
          user={user}
        />
      }
    />
  )
}
